<template>
    <div>
        <div class="text-center" v-if="!agbAccepted">
            <button
                class="btn btn-primary mb-2"
                data-toggle="modal"
                data-target="#agbModal"
            >
                {{ __("product.conditions.show_conditions") }}
            </button>
            <div class="form-text text-warning">
                {{ __("product.conditions.accept_ean_guidelines") }}
            </div>
        </div>

        <div
            class="modal fade"
            id="agbModal"
            tabindex="-1"
            role="dialog"
            data-backdrop="static"
            data-keyboard="false"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-title">
                        <h5 class="mb-0">
                            {{ __("product.conditions.ean_guidelines") }}
                        </h5>
                    </div>
                    <div class="modal-body text-left">
                        <span>
                            {{
                                __("product.conditions.agree_statement")
                            }} </span
                        ><br /><br />
                        <span>{{ __("product.conditions.agree_to") }}</span>
                        <ul>
                            <li>
                                {{
                                    __("product.conditions.correct_information")
                                }}
                            </li>
                            <li>
                                {{
                                    __(
                                        "product.conditions.responsibility_liability"
                                    )
                                }}
                            </li>
                            <li>
                                {{ __("product.conditions.more_info") }}
                                <span
                                    style="cursor: pointer"
                                    class="text-primary"
                                    @click="openEanAgb = !openEanAgb"
                                >
                                    {{
                                        __("product.conditions.ean_guidelines")
                                    }}
                                </span>
                            </li>
                        </ul>
                        <div v-show="openEanAgb" class="border-top">
                            <div class="font-size-h2 my-5 text-center">
                                {{
                                    __("product.conditions.ean_gtin_guidelines")
                                }}
                            </div>
                            <p>
                                {{
                                    __(
                                        "product.conditions.youbuyda_provided_ean_gtin"
                                    )
                                }}
                            </p>
                            <p>
                                {{
                                    __(
                                        "product.conditions.owner_responsibility"
                                    )
                                }}
                            </p>
                            <p>
                                {{
                                    __(
                                        "product.conditions.rights_obligations_liabilities"
                                    )
                                }}
                            </p>
                            <p>
                                {{
                                    __(
                                        "product.conditions.owner_sole_responsibility"
                                    )
                                }}
                            </p>
                            <p>
                                {{ __("product.conditions.owner_obligation") }}
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-around">
                        <button
                            type="button"
                            class="btn btn-secondary font-weight-bold"
                            data-dismiss="modal"
                        >
                            {{ __("actions.close") }}
                        </button>
                        <button
                            type="button"
                            @click="acceptAgb"
                            class="btn btn-primary font-weight-bold"
                        >
                            {{ __("actions.consent") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AcceptEanAgb",
    props: {
        customEan: { type: Boolean, default: false },
    },
    data() {
        return {
            openEanAgb: false,
            agbAccepted: false,
        };
    },
    mounted() {
        this.showAgbModal();
    },
    methods: {
        showAgbModal() {
            if (!this.agbAccepted) {
                $("#agbModal").modal("show");
            }
        },
        acceptAgb() {
            this.agbAccepted = true;
            $("#agbModal").modal("hide");
            this.$emit("acceptAgb");
        },
    },
};
</script>
